export const OLIVEEB_COLORS = {
  green: "#0B9B06",
  greenDark: "#066902",
  greenSoft: "#E7F8E7",
  greenSoft2: "#F6FFF6",
  red: "#AE0505",
  redSoft: "#FDECEC",
  textPrimary: "#062701",
  textSecondary: "#6A7A6B",
  ink: "#111111",
  border: "#E6EFE7",
  bgSoft: "#F7FAF7",
  line: "#EEF2EE",
  chip: "#E8EEF1",
  white: "#FFFFFF",
  shadow: "rgba(0,0,0,0.08)",

  oliveebOrange: "#e65100",
  oliveebYellow: "#f8c10b",
  oliveebBrightYellow: "#FFFF00",

  bg: "#F6FBF9",
  card: "#FFFFFF",

  oliveebGreen: "#27ae30",
  oliveebGreenSoft: "#E7F6EF",
  oliveebDarkGreen: "#0e5604",

  oliveebBlue: "#2385DB",
  oliveebDarkBlue: "#090359",
  oliveebBlueSoft: "#EAF4FF",

  goldSoft: "#FFF8DB",
  goldBorder: "#F6E9A7",

  textMuted: "#475569",
  placeholder: "#94A3B8",

  oliveebRed: "#d90101",
  oliveebDarkRed: "#5b0d03",

  overlay: "rgba(15, 23, 42, 0.35)",
};

export const workspaceStyles = {
  iconBubble: {
    border: `1px solid ${OLIVEEB_COLORS.oliveebBlueSoft}`,
    background: OLIVEEB_COLORS.oliveebBlueSoft,
    color: OLIVEEB_COLORS.oliveebBlue,
  },
  softCard: {
    borderRadius: 8,
    borderColor: OLIVEEB_COLORS.oliveebBlueSoft,
  },
  mutedPanel: {
    border: `1px solid ${OLIVEEB_COLORS.border}`,
    background: OLIVEEB_COLORS.bgSoft,
  },
  highlightedCard: {
    borderColor: OLIVEEB_COLORS.goldBorder,
    background: OLIVEEB_COLORS.goldSoft,
  },
};

export const workspaceButtonStyles = {
  back: {
    borderColor: OLIVEEB_COLORS.oliveebBlue,
    background: OLIVEEB_COLORS.oliveebBlueSoft,
    color: OLIVEEB_COLORS.oliveebBlue,
    fontWeight: 600,
  },
  charges: {
    borderColor: OLIVEEB_COLORS.oliveebRed,
    background: OLIVEEB_COLORS.redSoft,
    color: OLIVEEB_COLORS.oliveebRed,
    fontWeight: 600,
  },
  paymentMethods: {
    borderColor: OLIVEEB_COLORS.oliveebOrange,
    background: "#FFF3E8",
    color: OLIVEEB_COLORS.oliveebOrange,
    fontWeight: 600,
  },
  organization: {
    borderColor: OLIVEEB_COLORS.oliveebDarkGreen,
    background: OLIVEEB_COLORS.greenSoft2,
    color: OLIVEEB_COLORS.oliveebDarkGreen,
    fontWeight: 600,
  },
  refresh: {
    borderColor: OLIVEEB_COLORS.oliveebGreen,
    background: OLIVEEB_COLORS.oliveebGreenSoft,
    color: OLIVEEB_COLORS.oliveebGreen,
    fontWeight: 600,
  },
};
